export default __webpack_public_path__ + "static/img/ai_chat.9cbbaeb.png";